<template>
  <omint-page-content>
    <div class="term-box">
      <OmtTypography as="h1-bold" mb="16px">Verificação de identidade</OmtTypography>
      <OmtTypography as="h3-semi-bold" mb="16px">
        Insira o código que enviamos para o e-mail <br />{{ email }}.
      </OmtTypography>
      <CBox w="100%" mb="24px">
        <OmtInput
          type="text"
          v-model="input"
          border="0.5px solid var(--colors-light-secondary-divider)"
          borderRadius="8px"
          :placeholder="codePlaceholder"
          ref="inputFields"
          textAlign="center"
          fontSize="24px"
          letterSpacing="10px"
          fontWeight="700"
          p="0"
          w="100%"
          @focus="codePlaceholder = ''"
          @blur="codePlaceholder = '000000000'"
        />
      </CBox>
      <OmtTypography as="p1" mb="32px">
        Se você não receber o código, verifique sua caixa de spam ou clique abaixo em reenviar código.
      </OmtTypography>

      <CFlex justifyContent="center">
        <OmtButton variant="ghost" @click="reSendCode">
          <OmtTypography as="p1-bold" color="var(--colors-light-primary-navy-blue)" textAlign="center" cursor="pointer">
            Reenviar código
          </OmtTypography>
        </OmtButton>
      </CFlex>
    </div>
    <OmtButton
      variant="solid"
      width="100%"
      height="50px"
      border="0.5px solid var(--colors-light-secondary-divider)"
      borderRadius="40px"
      data-cy="button-entrar"
      @click="handleClick"
      :disabled="continueButtonDisabled"
      mb="3"
    >
      <OmtTypography as="h1-bold" color="white">Continuar</OmtTypography>
    </OmtButton>
  </omint-page-content>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

const minCodeLength = 8;

export default {
  name: "CodeCheck",
  mounted() {
    if (!this.hash) {
      this.$router.replace({ name: "first-access.terms" });
      return;
    }
    if (!this.email) {
      this.$router.push({ name: "first-access.mail-check" });
      return;
    }
    this.$root.$emit("change-title-label", "Confirmação de Identidade");
  },
  data() {
    return {
      input: "",
      codePlaceholder: "000000000"
    };
  },
  computed: {
    ...mapState("firstAccess", ["hash"]),
    continueButtonDisabled() {
      return this.input.length < minCodeLength;
    },
    email() {
      return this.$route.params.email ?? "";
    }
  },
  methods: {
    ...mapActions("firstAccess", ["checkCode", "sendCode"]),
    async handleClick() {
      await this.$root.$emit("show-loading");
      const error = await this.checkCode({ codigo: this.input });
      await this.$root.$emit("hide-loading");
      if (error === "") {
        await this.$router.push({ name: "first-access.password" });
      } else {
        Swal.fire({
          title: "Aviso",
          text: error,
          confirmButtonText: "Tentar novamente"
        });
      }
    },
    async reSendCode() {
      await this.$root.$emit("show-loading");
      try {
        await this.sendCode({ email: this.$route.params.email });
        Swal.fire({
          title: "Sucesso",
          text: "Novo código solicitado com sucesso!",
          confirmButtonText: "OK"
        });
      } catch (e) {
        console.error(e);
        Swal.fire({
          title: "Aviso",
          text: "Não foi possível enviar o código, tente novamente mais tarde.",
          confirmButtonText: "OK"
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.term-box {
  height: calc(100vh - 180px);
  overflow-y: auto;
}
</style>
